import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { currentUserShape } from '@adsk/bim360-matrix-react-helpers/es/propTypes';
import {
  getOrCreateGlobalContext,
  CONTEXT_NAMES
} from '@adsk/bim360-matrix-react-helpers/es/globalContexts';

const CurrentUserContext = getOrCreateGlobalContext(CONTEXT_NAMES.CurrentUserContext);

export const CurrentUserProvider = ({ currentUser, children }) => (
  <CurrentUserContext.Provider value={currentUser}>{children}</CurrentUserContext.Provider>
);

CurrentUserProvider.propTypes = {
  /**
   * The current logged in user.
   * `currentUser` is actually required, but when rendering it before the page loads we don't have a user yet.
   */
  currentUser: currentUserShape,
  children: PropTypes.node.isRequired
};

export const useCurrentUser = () => useContext(CurrentUserContext);

export default CurrentUserContext;
